import { apiGet, apiSend } from './client';

export interface Session {
  username: string;
}

export function whoami(): Promise<Session> {
  return apiGet<Session>('/auth/me');
}

export function login(username: string, password: string): Promise<Session> {
  return apiSend<Session>('/auth/login', 'POST', { username, password }) as Promise<Session>;
}

export function logout(): Promise<null> {
  return apiSend<null>('/auth/logout', 'POST');
}
